import { render, staticRenderFns } from "./HostMarketingMaterials.vue?vue&type=template&id=0cdd2e6c&"
import script from "./HostMarketingMaterials.vue?vue&type=script&lang=js&"
export * from "./HostMarketingMaterials.vue?vue&type=script&lang=js&"
import style0 from "./HostMarketingMaterials.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HostMarketingMaterials.vue"
export default component.exports